// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"97b989d1","239":"0129ee5e","455":"f0b456e8"}[chunkId] + ".chunk.js";
};